module.exports = __webpack_public_path__ + "assets/img/2.9b35397c.png";